import React from 'react';
import { Container } from '@common/components/container';
import { Icon } from '@common/components/icon';
import { Button } from '@common/components/button';
import { useTranslation } from 'react-i18next';


type NoNotesProps = {
  canCreateNotes: boolean;
  setIsNoteAddModalVisible: (isVisible: boolean) => void;
};

export const NoNotes = React.memo(({ canCreateNotes, setIsNoteAddModalVisible }: NoNotesProps) => {
  const { t } = useTranslation();
  const noNotesText = canCreateNotes ? t('core:no_notes_found_for_admin') : t('core:no_notes_found');

  return (
    <Container.Content className="tw-h-[calc(100vh-220px)]">
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full
        tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-p-4"
      >
        <div className="tw-flex tw-flex-col tw-w-[310px]
          tw-items-center tw-justify-center tw-gap-3
          tw-text-center"
        >
          <Icon type="document" size={48} className="tw-text-gray-500" />
          <p className="tw-text-center tw-text-gray-500 tw-text-md tw-m-0">{noNotesText}</p>

          {canCreateNotes && (
            <Button
              onClick={() => setIsNoteAddModalVisible(true)}
              type="primary" size="large" icon="add"
            >
              {t('core:add_note')}
            </Button>
          )}

        </div>
      </div>
    </Container.Content>
  );
});
